<app-header></app-header>
<main (scroll)="manageScroll($event)" #scrollContainer>
  <router-outlet
    (activate)="onActivate($event, scrollContainer)"
  ></router-outlet>
</main>
<app-footer *ngIf="(config$ | async)?.showFooter"></app-footer>
<app-loading *ngIf="loading"></app-loading>
<app-maintenance *ngIf="(config$ | async)?.maintenance"></app-maintenance>
